import { render, staticRenderFns } from "./provider-manager.vue?vue&type=template&id=0c115bb4"
import script from "./provider-manager.vue?vue&type=script&lang=js"
export * from "./provider-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports